import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import {
  Divider,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  NativeSelect,
  TextField,
  Typography,
} from "@material-ui/core";
import { blue } from "@material-ui/core/colors";
import CreateVehicle from "./MotorVehicleModal/Create";
import EditVehicle from "./MotorVehicleModal/Edit";
import DeleteVehicle from "./MotorVehicleModal/Delete";
import { EncryptStorage } from "encrypt-storage";
import Axios from "axios";
import moment from "moment";
import ShowNoteComponent from "./ShowNoteComponent";
import FileUpload from "../Components/FileUpload";
import Loading from "../../../pages/Loading"
import { debounce } from "lodash";
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import Position from "../../../modules/CustomizeComponent/PositionIcon";
import TextInputField from "../../../../_metronic/layout/components/InputFields";
import { Create } from "@material-ui/icons";
import GreenCheckBadge from "../Components/Badge";
const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
});

function MotorVehicleRow(props) {
  const { row, client_case_id, setVehicles } = props;
  const [open, setOpen] = useState(false);
  const classes = useRowStyles();
  const mobile = window.matchMedia("(max-width: 768px)");
  const [isMobile, setIsMobile] = useState(mobile.matches);

  useEffect(() => {
    const windowHandler = () => {
      setIsMobile(mobile.matches);
      if (!isMobile) {
        setOpen(false);
      }
    };

    mobile.addEventListener("change", windowHandler);
    return () => {
      mobile.removeEventListener("change", windowHandler);
    };
  }, []);
  
  const positions = [
    "Husband",
    "Wife",
    "Joint",
    "Client",
    "Spouse",
    "Third Party",
    "Other"
  ]; 

  const handleChange = debounce(async (property, value) => {
    try {
      if (value && value._isAMomentObject) {
        const date_dt = new Date(value);
        const new_date = new Date(
          date_dt.getFullYear(),
          date_dt.getMonth(),
          date_dt.getDate(),
          10,
          56,
          0
        );
        row[property] = new_date;
      } else {
        row[property] = value;
      }

      const response = await Axios.put(
        `api/estate/retirement/benefits/vehicle/${row.id}`,
        row
      );

      if (response && response.status === 200) {
        setVehicles(response.data.data);
      }
    } catch (err) {
      console.error("Error updating property:", err);
    }
  }, 500);

  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? (
              <KeyboardArrowDownIcon style={{ color: blue }} />
            ) : (
              <KeyboardArrowRightIcon />
            )}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row" className="font-weight-normal">
          {row.year} {row.make ?? "N/A"} {row.model} ({row.possession !== null && row.possession !== '' ? row.possession.slice(0,1) : ''}) <Position position ={row.position}/>
        </TableCell>
          <TableCell align="left" className="font-weight-normal">
            ${row.value ?? ""} as of ({moment(row.value_date).format("L")})
          </TableCell>
          <TableCell align="left" className="font-weight-normal">
            ${row.balance_loan ?? ""}
          </TableCell>
          <TableCell align="left" className="font-weight-normal">
            ${row.client_sp ?? ""}
          </TableCell>
        <TableCell align="left" className="font-weight-normal">
          ${row.spouse_sp ?? ""}
        </TableCell>
        <TableCell align="left" className="font-weight-normal">
          ${row.net_value ?? ""}
        </TableCell>
        <TableCell align="left">
          <ShowNoteComponent row={row} api='api/estate/retirement/benefits/vehicle'/>
          <div className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3">
            <DeleteVehicle row={row} setVehicles={setVehicles} />
          </div>
          <div className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3">
            <FileUpload row={row} client_case_id={client_case_id} source={'motor-vehicles'}/>
          </div>
           <GreenCheckBadge show={row.client_sp > 0 || row.spouse_sp > 0}/>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <div className="shadow mb-3">
                <List>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Year :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" > 
                       <TextInputField defaultValue={row.year} onChange={(e) => handleChange('year', e.target.value)}/>
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Make :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" > 
                       <TextInputField defaultValue={row.make} onChange={(e) => handleChange('make', e.target.value)}/>
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Model :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" > 
                       <TextInputField defaultValue={row.model} onChange={(e) => handleChange('model', e.target.value)}/>
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Name of title :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" > 
                       <TextInputField defaultValue={row.name} onChange={(e) => handleChange('name', e.target.value)}/>
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      In possession of :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" > 
                       <TextInputField defaultValue={row.possession} onChange={(e) => handleChange('possession', e.target.value)}/>
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      VIN # :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" > 
                       <TextInputField defaultValue={row.number} onChange={(e) => handleChange('number', e.target.value)}/>
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Value :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal d-flex align-center border-0 m-0 p-0" > 
                      <div>
                       <TextInputField
                        defaultValue={row.value}
                        onChange={(e) => handleChange('value', e.target.value)}
                      />
                      </div>
                      <div className="pt-3 px-5">
                      <Typography variant="p">as of</Typography> 
                      </div>
                      <div>
                      <MuiPickersUtilsProvider utils={MomentUtils}> 
                      <KeyboardDateTimePicker
                              disableToolbar
                              variant="inline"
                              format="MM/DD/yyyy"  
                              className="m-0"
                              id="date-picker-inline"
                              onChange={(value_date) => handleChange('value_date', value_date)}
                              value={new Date(row.value_date)} 
                              KeyboardButtonProps={{
                                  'aria-label': 'change date',
                              }}
                            />
                      </MuiPickersUtilsProvider>
                      </div> 
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Balance of loans :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" > 
                       <TextInputField defaultValue={row.balance_loan} onChange={(e) => handleChange('balance_loan', e.target.value)}/>
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Client SP:
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" > 
                       <TextInputField defaultValue={row.client_sp} onChange={(e) => handleChange('client_sp', e.target.value)}/>
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Spouse SP :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" >
                       <TextInputField defaultValue={row.spouse_sp} onChange={(e) => handleChange('spouse_sp', e.target.value)}/>
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Net Value :
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" >
                       <TextInputField defaultValue={row.net_value} disabled={true} />
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                  <ListItem button>
                    <ListItemText className="font-weight-normal">
                      Name/Control of:
                    </ListItemText>
                    <ListItemSecondaryAction className="font-weight-normal border-0 m-0 p-0" > 
                      <NativeSelect
                          className={`form-control form-control-solid h-auto mt-2 border-1 m-1 p-1 px-3`}
                          inputProps={{
                            name: 'positions',
                          }}
                        //  defaultValue={formik.values.type}
                          onChange={(e) => handleChange('position', e.target.value)} 
                          defaultValue={row.position}
                        >
                        {
                          positions.map((position, index) => {
                            return (
                              <option key={index} value={position}>{position}</option>
                            )
                          })
                        } 
                        </NativeSelect>
                    </ListItemSecondaryAction>
                  </ListItem>
                </List>
              </div>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

function MotorVehicle(props) {
  const { handleOpen } = props;
  const encryptStorage = new EncryptStorage("secret-key");
  const decypt_data = encryptStorage.getItem("case_details");
  const client_case_id = decypt_data ? decypt_data.case.id : null;
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(false); 
  const fetch_data = () => {
    setLoading(true);
    Axios.get("api/estate/retirement/benefits/vehicle/" + client_case_id)
      .then((res) => {
        setVehicles(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log("error", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetch_data();
  }, []);

  return (
    <>
      <div id="real-property" className={`card h-100 card-custom `}> 
           <div className="d-flex px-9 align-items-center">
                    <div className="ml-auto">
                      <CreateVehicle
                        setVehicles={setVehicles}
                        client_case_id={client_case_id}
                        handleOpen={handleOpen}
                      />
                    </div>
                  </div>
        <div className="pb-10 pl-10 pr-10 pt-0">
          <TableContainer component={Paper}>
            <Table aria-label="collapsible table">
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell className="font-weight-bold text-uppercase text-muted fs-1">
                    Description
                  </TableCell>
                  <TableCell
                    align="left"
                    className="font-weight-bold text-uppercase text-muted fs-1"
                  >
                    Value
                  </TableCell>
                  <TableCell
                    align="left"
                    className="font-weight-bold text-uppercase text-muted fs-1"
                  >
                    Debt
                  </TableCell>
                  <TableCell
                    align="left"
                    className="font-weight-bold text-uppercase text-muted fs-1"
                  >
                    Client SP
                  </TableCell>
                  <TableCell
                    align="left"
                    className="font-weight-bold text-uppercase text-muted fs-1"
                  >
                    Spouse SP
                  </TableCell>
                  <TableCell
                    align="left"
                    className="font-weight-bold text-uppercase text-muted fs-1"
                  >
                    Net Value
                  </TableCell>
                  <TableCell
                    align="left"
                    className="font-weight-bold text-uppercase text-muted fs-1"
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {vehicles.map((row) => (
                  <MotorVehicleRow
                    key={row.id}
                    row={row}
                    client_case_id={client_case_id}
                    setVehicles={setVehicles}
                  />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        {loading && <Loading/> }
      </div>
    </>
  );
}
export default MotorVehicle;
